"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceLocationTransport = void 0;
const common_1 = require("../common");
exports.ServiceLocationTransport = common_1.ServiceLocationTransport;
//# sourceMappingURL=service-location.js.map